module.exports = __webpack_public_path__ + "static/img/RO.626c0146.jpg";